<template>
    <div class="pageManager-m">
        <div class="jobMain">
            <div class="manager-rig">
                <div class="manager-rt">
                    <div class="manager-rtle">系统配置</div>
                </div>
                <div class="manager-setM">
                    <div class="manager-setMt">登录入口配置</div>
                    <div class="manager-set-entry-toolbar clearfix">
                        <el-input
                            v-model="entryQuery.entranceName"
                            placeholder="按入口名称搜索"
                            prefix-icon="el-icon-search"
                            clearable
                            class="manager-set-entry-search"
                            @keyup.enter.native="loadEntryList"
                            @clear="loadEntryList"
                        />
                        <el-button type="primary" plain @click="loadEntryList"><i class="el-icon-refresh"></i> 查询</el-button>
                        <el-button type="danger" class="manager-set-entry-add" @click="openEntryDialog('add')"><i class="el-icon-plus"></i> 新增入口</el-button>
                    </div>
                    <div class="manager-set-entry-table">
                        <table class="manager-job-table">
                            <tr>
                                <th width="18%" style="border-top-left-radius: 10px;">名称</th>
                                <th width="10%">类别</th>
                                <th width="32%">报名时间</th>
                                <th width="12%">状态</th>
                                <th width="28%" style="border-top-right-radius: 10px;">操作</th>
                            </tr>
                            <tr v-if="entryLoading">
                                <td colspan="5" class="manager-set-entry-empty">加载中...</td>
                            </tr>
                            <tr v-else-if="!entryList.length">
                                <td colspan="5" class="manager-set-entry-empty">暂无入口配置</td>
                            </tr>
                            <tr v-else v-for="item in entryList" :key="item.id">
                                <td>{{ item.entranceName }}</td>
                                <td>{{ item.entranceType }}</td>
                                <td>{{ formatEntryTimeRange(item) }}</td>
                                <td>
                                    <el-tag :type="entryStatusTag(item).type" size="mini">{{ entryStatusTag(item).label }}</el-tag>
                                </td>
                                <td>
                                    <el-button type="text" @click="openEntryDialog('edit', item)">编辑</el-button>
                                    <el-button type="text" class="entry-del-btn" @click="deleteEntry(item)">删除</el-button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="manager-setM manager-set-ocr">
                    <div class="manager-setMt">学信网学籍 OCR 识别配置</div>
                    <p class="manager-set-ocr-desc">按报名入口与最高学历，控制各学历段「学信网学籍验证报告」是否启用 OCR 自动识别。关闭后仅上传附件，信息需手动填写。</p>
                    <div v-loading="ocrConfigLoading" class="manager-set-ocr-body">
                        <div v-for="ent in ocrEntranceGroups" :key="'ocr-ent-' + ent.entranceType" class="ocr-entrance-block">
                            <div class="ocr-entrance-title">{{ ent.entranceLabel }}</div>
                            <div
                                v-for="group in ent.groups"
                                :key="'ocr-grp-' + ent.entranceType + '-' + group.highestEducation"
                                class="ocr-highest-block"
                            >
                                <div class="ocr-highest-title">最高学历：{{ group.highestEducation }}</div>
                                <div class="ocr-segment-row">
                                    <div
                                        v-for="seg in group.segments"
                                        :key="'ocr-seg-' + ent.entranceType + '-' + group.highestEducation + '-' + seg.segmentType"
                                        class="ocr-segment-item"
                                    >
                                        <span class="ocr-segment-label">{{ seg.label }} OCR</span>
                                        <el-switch
                                            v-model="seg.ocrEnabled"
                                            :active-value="1"
                                            :inactive-value="0"
                                            active-text="开"
                                            inactive-text="关"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ocr-save-row">
                            <el-button type="danger" :loading="ocrConfigSaving" @click="saveOcrConfig">保存 OCR 配置</el-button>
                        </div>
                    </div>
                </div>
                <div class="manager-setM manager-set-ticket">
                    <div class="manager-setMt">准考证打印开放时间</div>
                    <p class="manager-set-ocr-desc">可配置全局默认开放时间；也可为单个招聘岗位设置个性化时间。考生端优先使用岗位配置，无岗位配置时使用全局；均未配置时提示「另行通知」。</p>
                    <div class="ticket-global-block" v-loading="ticketGlobalLoading">
                        <div class="ticket-block-title">全局开放时间</div>
                        <el-date-picker
                            v-model="ticketGlobalRange"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            format="yyyy-MM-dd HH:mm"
                            style="width: 420px;"
                        />
                        <el-button type="danger" :loading="ticketGlobalSaving" style="margin-left: 12px;" @click="saveTicketGlobal">保存全局配置</el-button>
                    </div>
                    <div class="ticket-position-block">
                        <div class="ticket-block-title clearfix">
                            <span>岗位个性化开放时间</span>
                            <el-button type="danger" size="small" class="ticket-position-add" @click="openTicketPositionDialog()"><i class="el-icon-plus"></i> 新增岗位配置</el-button>
                        </div>
                        <div class="manager-set-entry-toolbar clearfix" style="padding-bottom: 12px;">
                            <el-radio-group v-model="ticketPositionTalentType" size="small" @change="loadTicketPositionList">
                                <el-radio-button :label="0">优培人才</el-radio-button>
                                <el-radio-button :label="1">技术人才</el-radio-button>
                                <el-radio-button :label="2">操作人才</el-radio-button>
                            </el-radio-group>
                        </div>
                        <div class="manager-set-entry-table" v-loading="ticketPositionLoading">
                            <table class="manager-job-table">
                                <tr>
                                    <th width="40%">岗位</th>
                                    <th width="40%">开放时间</th>
                                    <th width="20%">操作</th>
                                </tr>
                                <tr v-if="!ticketPositionList.length">
                                    <td colspan="3" class="manager-set-entry-empty">暂无岗位个性化配置</td>
                                </tr>
                                <tr v-for="item in ticketPositionList" :key="item.id">
                                    <td>{{ item.positionDisplayName || ('岗位ID ' + item.recruitPositionInfoId) }}</td>
                                    <td>{{ formatTicketTimeRange(item) }}</td>
                                    <td>
                                        <el-button type="text" @click="openTicketPositionDialog(item)">编辑</el-button>
                                        <el-button type="text" class="entry-del-btn" @click="deleteTicketPosition(item)">删除</el-button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <el-dialog :title="ticketPositionDialogTitle" :visible.sync="ticketPositionDialogVisible" width="520px">
                    <el-form label-width="100px">
                        <el-form-item label="招聘岗位" required>
                            <el-select
                                v-model="ticketPositionForm.recruitPositionInfoId"
                                filterable
                                placeholder="请选择岗位"
                                style="width: 100%;"
                                :disabled="!!ticketPositionForm.id">
                                <el-option
                                    v-for="p in ticketPositionOptions"
                                    :key="p.id"
                                    :label="p.label"
                                    :value="p.id"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开放时间" required>
                            <el-date-picker
                                v-model="ticketPositionForm.range"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始"
                                end-placeholder="结束"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm"
                                style="width: 100%;"
                            />
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input v-model="ticketPositionForm.remark" type="textarea" :rows="2" />
                        </el-form-item>
                    </el-form>
                    <span slot="footer">
                        <el-button @click="ticketPositionDialogVisible = false">取消</el-button>
                        <el-button type="danger" :loading="ticketPositionSaving" @click="saveTicketPosition">保存</el-button>
                    </span>
                </el-dialog>
                <div class="manager-setM manager-set-whitelist">
                    <div class="manager-setMt">毕业年限白名单人员配置</div>
                    <p class="manager-set-ocr-desc">配置后，报名保存时若「姓名 + 登录手机号」命中且为启用状态，则跳过毕业年限校验；停用后仍按岗位毕业年限要求正常校验。</p>
                    <div class="manager-set-entry-toolbar clearfix">
                        <el-input
                            v-model="gradWhitelistQuery.name"
                            placeholder="姓名"
                            prefix-icon="el-icon-user"
                            clearable
                            class="manager-set-entry-search"
                            @keyup.enter.native="loadGradWhitelistList(1)"
                            @clear="loadGradWhitelistList(1)"
                        />
                        <el-input
                            v-model="gradWhitelistQuery.phone"
                            placeholder="手机号"
                            clearable
                            class="manager-set-log-userid"
                            @keyup.enter.native="loadGradWhitelistList(1)"
                            @clear="loadGradWhitelistList(1)"
                        />
                        <el-button type="primary" plain @click="loadGradWhitelistList(1)"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button type="danger" class="manager-set-entry-add" @click="openGradWhitelistDialog('add')"><i class="el-icon-plus"></i> 新增</el-button>
                    </div>
                    <div class="manager-set-entry-table" v-loading="gradWhitelistLoading">
                        <table class="manager-job-table">
                            <tr>
                                <th width="8%" style="border-top-left-radius: 10px;">ID</th>
                                <th width="14%">姓名</th>
                                <th width="16%">手机号</th>
                                <th width="10%">状态</th>
                                <th width="22%">备注</th>
                                <th width="16%">创建时间</th>
                                <th width="14%" style="border-top-right-radius: 10px;">操作</th>
                            </tr>
                            <tr v-if="!gradWhitelistData.records || !gradWhitelistData.records.length">
                                <td colspan="7" class="manager-set-entry-empty">暂无白名单人员</td>
                            </tr>
                            <tr v-else v-for="row in gradWhitelistData.records" :key="row.id">
                                <td>{{ row.id }}</td>
                                <td>{{ row.name || '—' }}</td>
                                <td>{{ row.phone || '—' }}</td>
                                <td>
                                    <el-tag :type="row.enabled === 1 ? 'success' : 'info'" size="mini">
                                        {{ row.enabled === 1 ? '启用' : '停用' }}
                                    </el-tag>
                                </td>
                                <td class="log-url-cell" :title="row.remark">{{ row.remark || '—' }}</td>
                                <td>{{ formatGradWhitelistTime(row.createdTime) }}</td>
                                <td>
                                    <el-button type="text" @click="openGradWhitelistDialog('edit', row)">编辑</el-button>
                                    <el-switch
                                        :value="row.enabled === 1"
                                        active-text="启"
                                        inactive-text="停"
                                        :disabled="gradWhitelistStatusSavingId === row.id"
                                        @change="toggleGradWhitelistEnabled(row, $event)"
                                    />
                                </td>
                            </tr>
                        </table>
                        <div v-if="gradWhitelistData.total > 0" class="manager-set-log-page">
                            <el-pagination
                                background
                                :current-page="gradWhitelistData.current"
                                layout="total, prev, pager, next, sizes"
                                @current-change="changeGradWhitelistPage"
                                @size-change="changeGradWhitelistSize"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="gradWhitelistQuery.size"
                                :total="gradWhitelistData.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
                <div class="manager-setM manager-set-user">
                    <div class="manager-setMt">用户管理</div>
                    <div class="manager-set-entry-toolbar clearfix">
                        <el-input
                            v-model="userQuery.username"
                            placeholder="账号"
                            prefix-icon="el-icon-user"
                            clearable
                            class="manager-set-entry-search"
                            @keyup.enter.native="loadUserList(1)"
                        />
                        <el-input
                            v-model="userQuery.realName"
                            placeholder="姓名"
                            clearable
                            class="manager-set-log-userid"
                            @keyup.enter.native="loadUserList(1)"
                        />
                        <el-input
                            v-model="userQuery.phone"
                            placeholder="手机号"
                            clearable
                            class="manager-set-log-userid"
                            @keyup.enter.native="loadUserList(1)"
                        />
                        <el-select
                            v-model="userQuery.roleId"
                            placeholder="角色"
                            clearable
                            class="manager-set-log-success"
                        >
                            <el-option label="全部角色" value=""></el-option>
                            <el-option label="集团管理员" :value="0"></el-option>
                            <el-option label="二级单位管理员" :value="1"></el-option>
                            <el-option label="考生" :value="2"></el-option>
                        </el-select>
                        <el-select
                            v-model="userQuery.status"
                            placeholder="状态"
                            clearable
                            class="manager-set-log-success"
                        >
                            <el-option label="全部状态" value=""></el-option>
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="禁用" :value="0"></el-option>
                            <el-option label="待审核" :value="2"></el-option>
                        </el-select>
                        <el-button type="primary" plain @click="loadUserList(1)"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button type="danger" class="manager-set-entry-add" @click="openUserDialog"><i class="el-icon-plus"></i> 新增用户</el-button>
                    </div>
                    <div class="manager-set-entry-table">
                        <table class="manager-job-table">
                            <tr>
                                <th width="6%" style="border-top-left-radius: 10px;">ID</th>
                                <th width="12%">账号</th>
                                <th width="10%">姓名</th>
                                <th width="12%">手机号</th>
                                <th width="14%">邮箱</th>
                                <th width="12%">角色</th>
                                <th width="10%">状态</th>
                                <th width="14%">注册时间</th>
                                <th width="10%" style="border-top-right-radius: 10px;">操作</th>
                            </tr>
                            <tr v-if="userLoading">
                                <td colspan="9" class="manager-set-entry-empty">加载中...</td>
                            </tr>
                            <tr v-else-if="!userData.records || !userData.records.length">
                                <td colspan="9" class="manager-set-entry-empty">暂无用户</td>
                            </tr>
                            <tr v-else v-for="row in userData.records" :key="row.id">
                                <td>{{ row.id }}</td>
                                <td>{{ row.username || '—' }}</td>
                                <td>{{ row.realName || '—' }}</td>
                                <td>{{ row.phone || '—' }}</td>
                                <td class="log-url-cell" :title="row.email">{{ row.email || '—' }}</td>
                                <td>{{ formatUserRole(row.roleId) }}</td>
                                <td>
                                    <el-tag :type="userStatusTag(row).type" size="mini">{{ userStatusTag(row).label }}</el-tag>
                                </td>
                                <td>{{ formatUserTime(row.createTime) }}</td>
                                <td>
                                    <el-switch
                                        v-if="row.status === 0 || row.status === 1"
                                        :value="row.status === 1"
                                        active-text="启"
                                        inactive-text="禁"
                                        :disabled="userStatusSavingId === row.id"
                                        @change="toggleUserStatus(row, $event)"
                                    />
                                    <el-button
                                        v-else
                                        type="text"
                                        :loading="userStatusSavingId === row.id"
                                        @click="toggleUserStatus(row, true)"
                                    >启用</el-button>
                                </td>
                            </tr>
                        </table>
                        <div v-if="userData.total > 0" class="manager-set-log-page">
                            <el-pagination
                                background
                                :current-page="userData.current"
                                layout="total, prev, pager, next, sizes"
                                @current-change="changeUserPage"
                                @size-change="changeUserSize"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="userQuery.size"
                                :total="userData.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
                <div class="manager-setM manager-set-log">
                    <div class="manager-setMt">系统日志查询</div>
                    <div class="manager-set-entry-toolbar clearfix">
                        <el-input
                            v-model="logQuery.visitorName"
                            placeholder="访问人"
                            prefix-icon="el-icon-user"
                            clearable
                            class="manager-set-entry-search"
                            @keyup.enter.native="loadLogList(1)"
                        />
                        <el-input
                            v-model="logQuery.userId"
                            placeholder="用户ID"
                            clearable
                            class="manager-set-log-userid"
                            @keyup.enter.native="loadLogList(1)"
                        />
                        <el-input
                            v-model="logQuery.requestUrl"
                            placeholder="请求URL"
                            prefix-icon="el-icon-link"
                            clearable
                            class="manager-set-log-url"
                            @keyup.enter.native="loadLogList(1)"
                        />
                        <el-select
                            v-model="logQuery.success"
                            placeholder="结果"
                            clearable
                            class="manager-set-log-success"
                        >
                            <el-option label="全部" value=""></el-option>
                            <el-option label="成功" :value="1"></el-option>
                            <el-option label="失败" :value="0"></el-option>
                        </el-select>
                        <el-button type="primary" plain @click="loadLogList(1)"><i class="el-icon-search"></i> 查询</el-button>
                    </div>
                    <div class="manager-set-entry-table">
                        <table class="manager-job-table">
                            <tr>
                                <th width="10%" style="border-top-left-radius: 10px;">访问人</th>
                                <th width="8%">用户ID</th>
                                <th width="14%">访问时间</th>
                                <th width="6%">方法</th>
                                <th width="28%">URL</th>
                                <th width="8%">结果</th>
                                <th width="26%" style="border-top-right-radius: 10px;">操作</th>
                            </tr>
                            <tr v-if="logLoading">
                                <td colspan="7" class="manager-set-entry-empty">加载中...</td>
                            </tr>
                            <tr v-else-if="!logData.records || !logData.records.length">
                                <td colspan="7" class="manager-set-entry-empty">暂无访问日志</td>
                            </tr>
                            <tr v-else v-for="row in logData.records" :key="row.id">
                                <td>{{ row.visitorName || '—' }}</td>
                                <td>{{ row.userId != null ? row.userId : '—' }}</td>
                                <td>{{ formatLogTime(row.accessTime) }}</td>
                                <td>{{ row.requestMethod || '—' }}</td>
                                <td class="log-url-cell" :title="row.requestUrl">{{ row.requestUrl }}</td>
                                <td>
                                    <el-tag :type="row.success === 1 ? 'success' : 'danger'" size="mini">
                                        {{ row.success === 1 ? '成功' : '失败' }}
                                    </el-tag>
                                </td>
                                <td>
                                    <el-button type="text" @click="openLogDetail(row)">查看详情</el-button>
                                </td>
                            </tr>
                        </table>
                        <div v-if="logData.total > 0" class="manager-set-log-page">
                            <el-pagination
                                background
                                :current-page="logData.current"
                                layout="total, prev, pager, next, sizes"
                                @current-change="changeLogPage"
                                @size-change="changeLogSize"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="logQuery.size"
                                :total="logData.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="访问日志详情"
            :visible.sync="logDetailVisible"
            width="720px"
            class="log-detail-dialog"
        >
            <div v-if="logDetail" class="log-detail-body">
                <p><b>访问人：</b>{{ logDetail.visitorName || '—' }} &nbsp; <b>用户ID：</b>{{ logDetail.userId != null ? logDetail.userId : '—' }}</p>
                <p><b>时间：</b>{{ formatLogTime(logDetail.accessTime) }} &nbsp; <b>IP：</b>{{ logDetail.clientIp || '—' }}</p>
                <p><b>方法：</b>{{ logDetail.requestMethod || '—' }}</p>
                <p><b>URL：</b>{{ logDetail.requestUrl }}</p>
                <p><b>结果：</b>
                    <el-tag :type="logDetail.success === 1 ? 'success' : 'danger'" size="mini">
                        {{ logDetail.success === 1 ? '成功' : '失败' }}
                    </el-tag>
                </p>
                <p v-if="logDetail.errorMessage"><b>异常：</b>{{ logDetail.errorMessage }}</p>
                <p class="log-detail-label"><b>请求参数：</b></p>
                <pre class="log-detail-pre">{{ logDetail.requestParams || '—' }}</pre>
                <p class="log-detail-label"><b>返回值：</b></p>
                <pre class="log-detail-pre">{{ logDetail.responseBody || '—' }}</pre>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="logDetailVisible = false">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="gradWhitelistDialogMode === 'add' ? '新增白名单人员' : '编辑白名单人员'"
            :visible.sync="gradWhitelistDialogVisible"
            width="520px"
            :before-close="closeGradWhitelistDialog"
        >
            <el-form label-width="100px">
                <el-form-item label="姓名" required>
                    <el-input v-model="gradWhitelistForm.name" placeholder="与报名表姓名一致" maxlength="64" />
                </el-form-item>
                <el-form-item label="手机号" required>
                    <el-input v-model="gradWhitelistForm.phone" placeholder="与登录手机号一致" maxlength="20" />
                </el-form-item>
                <el-form-item label="状态" required>
                    <el-radio-group v-model="gradWhitelistForm.enabled">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="gradWhitelistForm.remark" type="textarea" :rows="2" maxlength="255" show-word-limit />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeGradWhitelistDialog">取消</el-button>
                <el-button type="danger" :loading="gradWhitelistSaving" @click="saveGradWhitelist">保存</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="新增用户"
            :visible.sync="userDialogVisible"
            width="520px"
            :before-close="closeUserDialog"
        >
            <el-form label-width="100px">
                <el-form-item label="用户类型" required>
                    <el-radio-group v-model="userForm.userKind" @change="onUserKindChange">
                        <el-radio label="admin">管理员</el-radio>
                        <el-radio label="candidate">考生</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="userForm.userKind === 'admin'" label="管理员级别" required>
                    <el-select v-model="userForm.adminRoleId" placeholder="请选择" style="width: 100%;">
                        <el-option label="集团管理员" :value="0"></el-option>
                        <el-option label="二级单位管理员" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="登录账号" required>
                    <el-input v-model="userForm.username" placeholder="建议使用手机号" maxlength="50" />
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="userForm.realName" placeholder="选填" maxlength="50" />
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="userForm.phone" placeholder="选填" maxlength="20" />
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="userForm.email" placeholder="选填" maxlength="100" />
                </el-form-item>
                <el-form-item label="初始密码">
                    <el-input v-model="userForm.password" type="password" placeholder="默认 123456" show-password maxlength="50" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeUserDialog">取消</el-button>
                <el-button type="danger" :loading="userSaving" @click="saveUser">保存</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="entryDialogMode === 'add' ? '新增入口' : '编辑入口'"
            :visible.sync="entryDialogVisible"
            width="520px"
            :before-close="closeEntryDialog"
        >
            <el-form label-width="100px">
                <el-form-item label="入口类别" required>
                    <el-input
                        v-model="entryForm.entranceType"
                        placeholder="请输入数字，如 0、1、2"
                        maxlength="9"
                        @input="onEntryFormEntranceTypeInput"
                    />
                </el-form-item>
                <el-form-item label="入口名称" required>
                    <el-input v-model="entryForm.entranceName" placeholder="如：优培人才" maxlength="50" />
                </el-form-item>
                <el-form-item label="开始时间">
                    <el-date-picker
                        v-model="entryForm.beginDate"
                        type="datetime"
                        placeholder="选择开始时间"
                        style="width: 100%;"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    />
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker
                        v-model="entryForm.endDate"
                        type="datetime"
                        placeholder="选择结束时间"
                        style="width: 100%;"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeEntryDialog">取消</el-button>
                <el-button type="danger" :loading="entrySaving" @click="saveEntry">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import axios from "axios";
import Cookies from "js-cookie";

/** 与报名表学历段一致的可配置项 */
const XUEXIN_OCR_SCHEMA = [
    {
        entranceType: 0,
        entranceLabel: '优培人才',
        groups: [
            {
                highestEducation: '硕士研究生',
                segments: [
                    { segmentType: '本科', label: '本科信息' },
                    { segmentType: '研究生', label: '研究生信息' },
                ],
            },
            {
                highestEducation: '博士研究生',
                segments: [
                    { segmentType: '本科', label: '本科信息' },
                    { segmentType: '研究生', label: '研究生信息' },
                    { segmentType: '博士', label: '博士信息' },
                ],
            },
        ],
    },
    {
        entranceType: 1,
        entranceLabel: '技术人才',
        groups: [
            {
                highestEducation: '本科',
                segments: [{ segmentType: '本科', label: '本科信息' }],
            },
            {
                highestEducation: '硕士研究生',
                segments: [
                    { segmentType: '本科', label: '本科信息' },
                    { segmentType: '研究生', label: '研究生信息' },
                ],
            },
            {
                highestEducation: '博士研究生',
                segments: [
                    { segmentType: '本科', label: '本科信息' },
                    { segmentType: '研究生', label: '研究生信息' },
                    { segmentType: '博士', label: '博士信息' },
                ],
            },
        ],
    },
    {
        entranceType: 2,
        entranceLabel: '操作人才',
        groups: [
            {
                highestEducation: '专科',
                segments: [{ segmentType: '专科', label: '专科信息' }],
            },
            {
                highestEducation: '本科',
                segments: [{ segmentType: '本科', label: '本科信息' }],
            },
            {
                highestEducation: '硕士研究生',
                segments: [
                    { segmentType: '本科', label: '本科信息' },
                    { segmentType: '研究生', label: '研究生信息' },
                ],
            },
            {
                highestEducation: '博士研究生',
                segments: [
                    { segmentType: '本科', label: '本科信息' },
                    { segmentType: '研究生', label: '研究生信息' },
                    { segmentType: '博士', label: '博士信息' },
                ],
            },
        ],
    },
];

export default {
    name: 'PageManagerSet',
    data() {
        return {
            userInfo: null,
            entryQuery: {
                entranceName: '',
            },
            entryList: [],
            entryLoading: false,
            entryDialogVisible: false,
            entryDialogMode: 'add',
            entrySaving: false,
            entryForm: {
                id: null,
                entranceType: '',
                entranceName: '',
                beginDate: '',
                endDate: '',
            },
            logQuery: {
                current: 1,
                size: 10,
                visitorName: '',
                userId: '',
                requestUrl: '',
                success: '',
            },
            logData: {
                records: [],
                total: 0,
                current: 1,
                size: 10,
            },
            logLoading: false,
            logDetailVisible: false,
            logDetail: null,
            ocrEntranceGroups: [],
            ocrConfigLoading: false,
            ocrConfigSaving: false,
            userQuery: {
                current: 1,
                size: 10,
                username: '',
                realName: '',
                phone: '',
                roleId: '',
                status: '',
            },
            userData: {
                records: [],
                total: 0,
                current: 1,
                size: 10,
            },
            userLoading: false,
            userDialogVisible: false,
            userSaving: false,
            userStatusSavingId: null,
            userForm: {
                userKind: 'candidate',
                adminRoleId: 0,
                username: '',
                realName: '',
                phone: '',
                email: '',
                password: '',
            },
            ticketGlobalRange: [],
            ticketGlobalLoading: false,
            ticketGlobalSaving: false,
            ticketPositionList: [],
            ticketPositionLoading: false,
            ticketPositionTalentType: 0,
            ticketPositionOptions: [],
            ticketPositionDialogVisible: false,
            ticketPositionDialogTitle: '新增岗位配置',
            ticketPositionSaving: false,
            ticketPositionForm: {
                id: null,
                recruitPositionInfoId: null,
                range: [],
                remark: '',
            },
            gradWhitelistQuery: {
                current: 1,
                size: 10,
                name: '',
                phone: '',
            },
            gradWhitelistData: {
                records: [],
                total: 0,
                current: 1,
                size: 10,
            },
            gradWhitelistLoading: false,
            gradWhitelistDialogVisible: false,
            gradWhitelistDialogMode: 'add',
            gradWhitelistSaving: false,
            gradWhitelistStatusSavingId: null,
            gradWhitelistForm: {
                id: null,
                name: '',
                phone: '',
                enabled: 1,
                remark: '',
            },
        }
    },
    mounted() {
        document.title = '潞安招聘-系统配置';
        if (Cookies.get('reqToKen')) {
            this.loadEntryList();
            this.loadOcrConfig();
            this.loadTicketGlobal();
            this.loadTicketPositionList();
            this.loadGradWhitelistList(1);
            this.loadUserList(1);
            this.loadLogList(1);
        }
    },
    methods: {
        authHeaders() {
            return { Authorization: Cookies.get('reqToKen') };
        },
        apiOk(res) {
            const d = res.data;
            return d && (d.success === true || d.code === 200);
        },
        formatEntryTimeRange(item) {
            const b = item.beginDate ? this.$moment(item.beginDate).format('M月D日 HH:mm') : '';
            const e = item.endDate ? this.$moment(item.endDate).format('M月D日 HH:mm') : '';
            if (b && e) {
                return `${b} - ${e}`;
            }
            return b || e || '-';
        },
        entryStatusTag(item) {
            const now = this.$moment();
            const start = item.beginDate ? this.$moment(item.beginDate) : null;
            const end = item.endDate ? this.$moment(item.endDate) : null;
            if (start && start.isValid() && now.isBefore(start)) {
                return { label: '未开始', type: 'info' };
            }
            if (end && end.isValid() && now.isAfter(end)) {
                return { label: '已结束', type: 'danger' };
            }
            if ((start && start.isValid()) || (end && end.isValid())) {
                return { label: '进行中', type: 'success' };
            }
            return { label: '未设置时间', type: 'warning' };
        },
        normalizeEntryList(data) {
            if (Array.isArray(data)) {
                return data;
            }
            if (data && Array.isArray(data.records)) {
                return data.records;
            }
            return [];
        },
        loadEntryList() {
            if (!Cookies.get('reqToKen')) {
                return;
            }
            this.entryLoading = true;
            const params = {};
            const name = String(this.entryQuery.entranceName || '').trim();
            if (name) {
                params.entranceName = name;
            }
            const queryType = String(this.entryQuery.entranceType || '').trim();
            if (queryType !== '') {
                params.entranceType = Number(queryType);
            }
            axios.get('/zhaopinapi/entrance/find-all', {
                headers: this.authHeaders(),
                params,
            }).then((res) => {
                if (this.apiOk(res)) {
                    this.entryList = this.normalizeEntryList(res.data.data);
                    this.entryList.sort((a, b) => (a.entranceType ?? 0) - (b.entranceType ?? 0));
                } else {
                    this.$message.warning(res.data.message || '查询入口配置失败');
                }
            }).catch((error) => {
                console.log(error);
                this.$message.error('查询入口配置失败');
            }).finally(() => {
                this.entryLoading = false;
            });
        },
        openEntryDialog(mode, row) {
            this.entryDialogMode = mode;
            if (mode === 'edit' && row && row.id) {
                axios.get('/zhaopinapi/entrance/find-by-id/' + row.id, {
                    headers: this.authHeaders(),
                }).then((res) => {
                    if (this.apiOk(res) && res.data.data) {
                        const d = res.data.data;
                        this.entryForm = {
                            id: d.id,
                            entranceType: this.toEntranceTypeInput(d.entranceType),
                            entranceName: d.entranceName,
                            beginDate: d.beginDate || '',
                            endDate: d.endDate || '',
                        };
                    } else {
                        this.fillEntryFormFromRow(row);
                    }
                    this.entryDialogVisible = true;
                }).catch(() => {
                    this.fillEntryFormFromRow(row);
                    this.entryDialogVisible = true;
                });
                return;
            }
            this.entryForm = {
                id: null,
                entranceType: '',
                entranceName: '',
                beginDate: '',
                endDate: '',
            };
            this.entryDialogVisible = true;
        },
        fillEntryFormFromRow(row) {
            this.entryForm = {
                id: row.id,
                entranceType: this.toEntranceTypeInput(row.entranceType),
                entranceName: row.entranceName,
                beginDate: row.beginDate || '',
                endDate: row.endDate || '',
            };
        },
        closeEntryDialog() {
            this.entryDialogVisible = false;
            this.entrySaving = false;
        },
        sanitizeDigitOnly(val) {
            return String(val == null ? '' : val).replace(/\D/g, '');
        },
        toEntranceTypeInput(val) {
            if (val === null || val === undefined || val === '') {
                return '';
            }
            return this.sanitizeDigitOnly(val);
        },
        onQueryEntranceTypeInput(val) {
            this.entryQuery.entranceType = this.sanitizeDigitOnly(val);
        },
        onEntryFormEntranceTypeInput(val) {
            this.entryForm.entranceType = this.sanitizeDigitOnly(val);
        },
        validateEntryForm() {
            const entranceType = String(this.entryForm.entranceType || '').trim();
            if (entranceType === '') {
                this.$message.error('请输入入口类别');
                return false;
            }
            if (!/^\d+$/.test(entranceType)) {
                this.$message.error('入口类别只能输入数字');
                return false;
            }
            if (!this.entryForm.entranceName || !String(this.entryForm.entranceName).trim()) {
                this.$message.error('请输入入口名称');
                return false;
            }
            if (this.entryForm.beginDate && this.entryForm.endDate
                && this.$moment(this.entryForm.endDate).isBefore(this.entryForm.beginDate)) {
                this.$message.error('结束时间不能早于开始时间');
                return false;
            }
            return true;
        },
        saveEntry() {
            if (!this.validateEntryForm()) {
                return;
            }
            this.entrySaving = true;
            const isAdd = this.entryDialogMode === 'add';
            const payload = {
                entranceType: Number(String(this.entryForm.entranceType).trim()),
                entranceName: String(this.entryForm.entranceName).trim(),
                beginDate: this.entryForm.beginDate || '',
                endDate: this.entryForm.endDate || '',
            };
            if (!isAdd && this.entryForm.id != null && this.entryForm.id !== '') {
                payload.id = this.entryForm.id;
            }
            const headers = this.authHeaders();
            const request = isAdd
                ? axios.post('/zhaopinapi/entrance/insert', payload, { headers })
                : axios.put('/zhaopinapi/entrance/update', payload, { headers });

            request.then((res) => {
                if (this.apiOk(res)) {
                    this.$message.success(this.entryDialogMode === 'add' ? '新增成功' : '修改成功');
                    this.closeEntryDialog();
                    this.loadEntryList();
                } else {
                    this.$message.error(res.data.message || '保存失败');
                }
            }).catch((error) => {
                console.log(error);
                const msg = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : '保存失败';
                this.$message.error(msg);
            }).finally(() => {
                this.entrySaving = false;
            });
        },
        deleteEntry(row) {
            this.$confirm(`确定删除入口「${row.entranceName}」吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                axios.delete('/zhaopinapi/entrance/delete/' + row.id, {
                    headers: this.authHeaders(),
                }).then((res) => {
                    if (this.apiOk(res)) {
                        this.$message.success('删除成功');
                        this.loadEntryList();
                    } else {
                        this.$message.error(res.data.message || '删除失败');
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$message.error('删除失败');
                });
            }).catch(() => {});
        },
        formatLogTime(t) {
            if (!t) {
                return '—';
            }
            return this.$moment(t).format('YYYY-MM-DD HH:mm:ss');
        },
        buildLogParams() {
            const params = {
                current: this.logQuery.current,
                size: this.logQuery.size,
            };
            const name = String(this.logQuery.visitorName || '').trim();
            if (name) {
                params.visitorName = name;
            }
            const uid = String(this.logQuery.userId || '').trim();
            if (uid) {
                params.userId = uid;
            }
            const url = String(this.logQuery.requestUrl || '').trim();
            if (url) {
                params.requestUrl = url;
            }
            if (this.logQuery.success === 0 || this.logQuery.success === 1) {
                params.success = this.logQuery.success;
            }
            return params;
        },
        loadLogList(pn) {
            if (!Cookies.get('reqToKen')) {
                return;
            }
            if (pn) {
                this.logQuery.current = pn;
            }
            this.logLoading = true;
            axios.get('/zhaopinapi/system-access-log/find-page', {
                headers: this.authHeaders(),
                params: this.buildLogParams(),
            }).then((res) => {
                if (this.apiOk(res) && res.data.data) {
                    this.logData = res.data.data;
                    this.logQuery.current = this.logData.current || this.logQuery.current;
                    this.logQuery.size = this.logData.size || this.logQuery.size;
                } else {
                    this.$message.warning(res.data.message || '查询系统日志失败');
                    this.logData = { records: [], total: 0, current: 1, size: this.logQuery.size };
                }
            }).catch((error) => {
                console.log(error);
                const msg = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : '查询系统日志失败';
                this.$message.error(msg);
            }).finally(() => {
                this.logLoading = false;
            });
        },
        changeLogPage(currentPage) {
            this.logQuery.current = currentPage;
            this.loadLogList();
        },
        changeLogSize(val) {
            this.logQuery.size = val;
            this.loadLogList(1);
        },
        buildOcrEntranceGroupsFromApi(list) {
            const map = {};
            (list || []).forEach((row) => {
                const key = `${row.entranceType}_${row.highestEducation}_${row.segmentType}`;
                map[key] = row.ocrEnabled === 1 ? 1 : 0;
            });
            return XUEXIN_OCR_SCHEMA.map((ent) => ({
                entranceType: ent.entranceType,
                entranceLabel: ent.entranceLabel,
                groups: ent.groups.map((g) => ({
                    highestEducation: g.highestEducation,
                    segments: g.segments.map((s) => {
                        const cfgKey = `${ent.entranceType}_${g.highestEducation}_${s.segmentType}`;
                        return {
                            segmentType: s.segmentType,
                            label: s.label,
                            ocrEnabled: map[cfgKey] != null ? map[cfgKey] : 1,
                        };
                    }),
                })),
            }));
        },
        loadOcrConfig() {
            if (!Cookies.get('reqToKen')) {
                return;
            }
            this.ocrConfigLoading = true;
            axios.get('/zhaopinapi/xuexin-ocr-config/find-all', {
                headers: this.authHeaders(),
            }).then((res) => {
                if (this.apiOk(res)) {
                    this.ocrEntranceGroups = this.buildOcrEntranceGroupsFromApi(res.data.data);
                } else {
                    this.ocrEntranceGroups = this.buildOcrEntranceGroupsFromApi([]);
                    this.$message.warning(res.data.message || '查询 OCR 配置失败');
                }
            }).catch((error) => {
                console.log(error);
                this.ocrEntranceGroups = this.buildOcrEntranceGroupsFromApi([]);
                this.$message.error('查询 OCR 配置失败');
            }).finally(() => {
                this.ocrConfigLoading = false;
            });
        },
        formatUserRole(roleId) {
            const map = {0: '集团管理员', 1: '二级单位管理员', 2: '考生'};
            const key = roleId == null ? '' : Number(roleId);
            return map[key] != null ? map[key] : '—';
        },
        userStatusTag(row) {
            if (row.status === 1) {
                return { label: '启用', type: 'success' };
            }
            if (row.status === 0) {
                return { label: '禁用', type: 'danger' };
            }
            if (row.status === 2) {
                return { label: '待审核', type: 'warning' };
            }
            return { label: '未知', type: 'info' };
        },
        formatUserTime(val) {
            if (!val) {
                return '—';
            }
            const m = this.$moment(val);
            return m.isValid() ? m.format('YYYY-MM-DD HH:mm') : String(val);
        },
        formatGradWhitelistTime(val) {
            return this.formatUserTime(val);
        },
        loadGradWhitelistList(page) {
            if (!Cookies.get('reqToKen')) {
                return;
            }
            if (page != null) {
                this.gradWhitelistQuery.current = page;
            }
            this.gradWhitelistLoading = true;
            const params = {
                current: this.gradWhitelistQuery.current,
                size: this.gradWhitelistQuery.size,
            };
            const name = String(this.gradWhitelistQuery.name || '').trim();
            const phone = String(this.gradWhitelistQuery.phone || '').trim();
            if (name) {
                params.name = name;
            }
            if (phone) {
                params.phone = phone;
            }
            axios.get('/zhaopinapi/graduation-years-whitelist/page', {
                headers: this.authHeaders(),
                params,
            }).then((res) => {
                if (this.apiOk(res) && res.data.data) {
                    const d = res.data.data;
                    this.gradWhitelistData = {
                        records: d.records || [],
                        total: d.total || 0,
                        current: d.current || this.gradWhitelistQuery.current,
                        size: d.size || this.gradWhitelistQuery.size,
                    };
                } else {
                    this.gradWhitelistData = { records: [], total: 0, current: 1, size: this.gradWhitelistQuery.size };
                    this.$message.warning(res.data.message || '查询白名单失败');
                }
            }).catch((error) => {
                console.log(error);
                this.$message.error('查询白名单失败');
            }).finally(() => {
                this.gradWhitelistLoading = false;
            });
        },
        changeGradWhitelistPage(p) {
            this.gradWhitelistQuery.current = p;
            this.loadGradWhitelistList();
        },
        changeGradWhitelistSize(size) {
            this.gradWhitelistQuery.size = size;
            this.loadGradWhitelistList(1);
        },
        openGradWhitelistDialog(mode, row) {
            this.gradWhitelistDialogMode = mode;
            if (mode === 'edit' && row && row.id) {
                this.gradWhitelistForm = {
                    id: row.id,
                    name: row.name || '',
                    phone: row.phone || '',
                    enabled: row.enabled === 0 ? 0 : 1,
                    remark: row.remark || '',
                };
                this.gradWhitelistDialogVisible = true;
                return;
            }
            this.gradWhitelistForm = {
                id: null,
                name: '',
                phone: '',
                enabled: 1,
                remark: '',
            };
            this.gradWhitelistDialogVisible = true;
        },
        closeGradWhitelistDialog() {
            this.gradWhitelistDialogVisible = false;
            this.gradWhitelistSaving = false;
        },
        validateGradWhitelistForm() {
            const name = String(this.gradWhitelistForm.name || '').trim();
            const phone = String(this.gradWhitelistForm.phone || '').trim();
            if (!name) {
                this.$message.error('请输入姓名');
                return false;
            }
            if (!phone) {
                this.$message.error('请输入手机号');
                return false;
            }
            return true;
        },
        saveGradWhitelist() {
            if (!this.validateGradWhitelistForm()) {
                return;
            }
            const payload = {
                name: String(this.gradWhitelistForm.name).trim(),
                phone: String(this.gradWhitelistForm.phone).trim(),
                enabled: this.gradWhitelistForm.enabled === 0 ? 0 : 1,
                remark: String(this.gradWhitelistForm.remark || '').trim(),
            };
            this.gradWhitelistSaving = true;
            const req = this.gradWhitelistDialogMode === 'edit' && this.gradWhitelistForm.id
                ? axios.put('/zhaopinapi/graduation-years-whitelist/' + this.gradWhitelistForm.id, payload, {
                    headers: this.authHeaders(),
                })
                : axios.post('/zhaopinapi/graduation-years-whitelist', payload, {
                    headers: this.authHeaders(),
                });
            req.then((res) => {
                if (this.apiOk(res)) {
                    this.$message.success('保存成功');
                    this.closeGradWhitelistDialog();
                    this.loadGradWhitelistList(this.gradWhitelistDialogMode === 'add' ? 1 : this.gradWhitelistQuery.current);
                } else {
                    this.$message.error(res.data.message || '保存失败');
                }
            }).catch((error) => {
                console.log(error);
                const msg = (error.response && error.response.data && error.response.data.message)
                    || '保存失败';
                this.$message.error(msg);
            }).finally(() => {
                this.gradWhitelistSaving = false;
            });
        },
        toggleGradWhitelistEnabled(row, enabled) {
            if (!row || !row.id) {
                return;
            }
            const nextEnabled = enabled ? 1 : 0;
            const actionLabel = nextEnabled === 1 ? '启用' : '停用';
            this.$confirm(`确定要${actionLabel}白名单人员「${row.name || row.phone}」吗？`, '提示', {
                type: 'warning',
            }).then(() => {
                this.gradWhitelistStatusSavingId = row.id;
                axios.put('/zhaopinapi/graduation-years-whitelist/' + row.id + '/enabled', null, {
                    headers: this.authHeaders(),
                    params: { enabled: nextEnabled },
                }).then((res) => {
                    if (this.apiOk(res)) {
                        this.$message.success(`${actionLabel}成功`);
                        row.enabled = nextEnabled;
                    } else {
                        this.$message.error(res.data.message || `${actionLabel}失败`);
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$message.error(`${actionLabel}失败`);
                }).finally(() => {
                    this.gradWhitelistStatusSavingId = null;
                });
            }).catch(() => {});
        },
        loadUserList(page) {
            if (!Cookies.get('reqToKen')) {
                return;
            }
            if (page != null) {
                this.userQuery.current = page;
            }
            this.userLoading = true;
            const params = {
                current: this.userQuery.current,
                size: this.userQuery.size,
            };
            const username = String(this.userQuery.username || '').trim();
            const realName = String(this.userQuery.realName || '').trim();
            const phone = String(this.userQuery.phone || '').trim();
            if (username) {
                params.username = username;
            }
            if (realName) {
                params.realName = realName;
            }
            if (phone) {
                params.phone = phone;
            }
            if (this.userQuery.roleId !== '' && this.userQuery.roleId !== null && this.userQuery.roleId !== undefined) {
                params.roleId = this.userQuery.roleId;
            }
            if (this.userQuery.status !== '' && this.userQuery.status !== null && this.userQuery.status !== undefined) {
                params.status = this.userQuery.status;
            }
            axios.get('/zhaopinapi/users', {
                headers: this.authHeaders(),
                params,
            }).then((res) => {
                if (this.apiOk(res) && res.data.data) {
                    const d = res.data.data;
                    this.userData = {
                        records: d.records || [],
                        total: d.total || 0,
                        current: d.current || this.userQuery.current,
                        size: d.size || this.userQuery.size,
                    };
                } else {
                    this.userData = { records: [], total: 0, current: 1, size: this.userQuery.size };
                    this.$message.warning(res.data.message || '查询用户失败');
                }
            }).catch((error) => {
                console.log(error);
                this.$message.error('查询用户失败');
            }).finally(() => {
                this.userLoading = false;
            });
        },
        changeUserPage(p) {
            this.userQuery.current = p;
            this.loadUserList();
        },
        changeUserSize(size) {
            this.userQuery.size = size;
            this.loadUserList(1);
        },
        openUserDialog() {
            this.userForm = {
                userKind: 'candidate',
                adminRoleId: 0,
                username: '',
                realName: '',
                phone: '',
                email: '',
                password: '',
            };
            this.userDialogVisible = true;
        },
        closeUserDialog() {
            this.userDialogVisible = false;
            this.userSaving = false;
        },
        onUserKindChange() {
            if (this.userForm.userKind === 'candidate') {
                this.userForm.adminRoleId = 0;
            }
        },
        validateUserForm() {
            const username = String(this.userForm.username || '').trim();
            if (!username) {
                this.$message.error('请输入登录账号');
                return false;
            }
            if (this.userForm.userKind === 'admin' && (this.userForm.adminRoleId !== 0 && this.userForm.adminRoleId !== 1)) {
                this.$message.error('请选择管理员级别');
                return false;
            }
            return true;
        },
        saveUser() {
            if (!this.validateUserForm()) {
                return;
            }
            const roleId = this.userForm.userKind === 'candidate' ? 2 : this.userForm.adminRoleId;
            const payload = {
                username: String(this.userForm.username).trim(),
                realName: String(this.userForm.realName || '').trim(),
                phone: String(this.userForm.phone || '').trim(),
                email: String(this.userForm.email || '').trim(),
                roleId,
            };
            const pwd = String(this.userForm.password || '').trim();
            if (pwd) {
                payload.password = pwd;
            }
            this.userSaving = true;
            axios.post('/zhaopinapi/users/admin-create', payload, {
                headers: this.authHeaders(),
            }).then((res) => {
                if (this.apiOk(res)) {
                    this.$message.success('用户创建成功');
                    this.closeUserDialog();
                    this.loadUserList(1);
                } else {
                    this.$message.error(res.data.message || '创建失败');
                }
            }).catch((error) => {
                console.log(error);
                const msg = (error.response && error.response.data && error.response.data.message)
                    || '创建用户失败';
                this.$message.error(msg);
            }).finally(() => {
                this.userSaving = false;
            });
        },
        toggleUserStatus(row, enabled) {
            if (!row || !row.id) {
                return;
            }
            const status = enabled ? 1 : 0;
            const actionLabel = status === 1 ? '启用' : '禁用';
            this.$confirm(`确定要${actionLabel}用户「${row.username || row.id}」吗？`, '提示', {
                type: 'warning',
            }).then(() => {
                this.userStatusSavingId = row.id;
                axios.post(`/zhaopinapi/users/${row.id}/toggle-status`, null, {
                    headers: this.authHeaders(),
                    params: { status },
                }).then((res) => {
                    if (this.apiOk(res)) {
                        this.$message.success(res.data.message || `${actionLabel}成功`);
                        row.status = status;
                    } else {
                        this.$message.error(res.data.message || `${actionLabel}失败`);
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$message.error(`${actionLabel}失败`);
                }).finally(() => {
                    this.userStatusSavingId = null;
                });
            }).catch(() => {});
        },
        saveOcrConfig() {
            if (!Cookies.get('reqToKen')) {
                this.$message.error('请先登录');
                return;
            }
            const items = [];
            this.ocrEntranceGroups.forEach((ent) => {
                ent.groups.forEach((group) => {
                    group.segments.forEach((seg) => {
                        items.push({
                            entranceType: ent.entranceType,
                            highestEducation: group.highestEducation,
                            segmentType: seg.segmentType,
                            ocrEnabled: seg.ocrEnabled === 1 ? 1 : 0,
                        });
                    });
                });
            });
            this.ocrConfigSaving = true;
            axios.put('/zhaopinapi/xuexin-ocr-config/batch-save', items, {
                headers: this.authHeaders(),
            }).then((res) => {
                if (this.apiOk(res)) {
                    this.$message.success('OCR 配置已保存');
                    this.loadOcrConfig();
                } else {
                    this.$message.warning(res.data.message || '保存失败');
                }
            }).catch((error) => {
                console.log(error);
                this.$message.error('保存 OCR 配置失败');
            }).finally(() => {
                this.ocrConfigSaving = false;
            });
        },
        formatTicketTimeRange(item) {
            if (!item || !item.openStart || !item.openEnd) {
                return '-';
            }
            const b = this.$moment(item.openStart).format('YYYY-MM-DD HH:mm');
            const e = this.$moment(item.openEnd).format('YYYY-MM-DD HH:mm');
            return `${b} 至 ${e}`;
        },
        loadTicketGlobal() {
            this.ticketGlobalLoading = true;
            axios.get('/zhaopinapi/exam-ticket-print-window/global', {
                headers: this.authHeaders(),
            }).then((res) => {
                if (this.apiOk(res) && res.data.data && res.data.data.openStart && res.data.data.openEnd) {
                    this.ticketGlobalRange = [res.data.data.openStart, res.data.data.openEnd];
                } else {
                    this.ticketGlobalRange = [];
                }
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                this.ticketGlobalLoading = false;
            });
        },
        saveTicketGlobal() {
            if (!this.ticketGlobalRange || this.ticketGlobalRange.length !== 2) {
                this.$message.warning('请选择全局开放时间');
                return;
            }
            this.ticketGlobalSaving = true;
            axios.put('/zhaopinapi/exam-ticket-print-window/save', {
                scopeType: 0,
                openStart: this.ticketGlobalRange[0],
                openEnd: this.ticketGlobalRange[1],
            }, { headers: this.authHeaders() }).then((res) => {
                if (this.apiOk(res)) {
                    this.$message.success('全局配置已保存');
                    this.loadTicketGlobal();
                } else {
                    this.$message.warning(res.data.message || '保存失败');
                }
            }).catch(() => {
                this.$message.error('保存失败');
            }).finally(() => {
                this.ticketGlobalSaving = false;
            });
        },
        loadTicketPositionList() {
            this.ticketPositionLoading = true;
            axios.get('/zhaopinapi/exam-ticket-print-window/position/list', {
                headers: this.authHeaders(),
                params: { talentType: this.ticketPositionTalentType },
            }).then((res) => {
                if (this.apiOk(res)) {
                    this.ticketPositionList = res.data.data || [];
                } else {
                    this.ticketPositionList = [];
                }
            }).catch((error) => {
                console.log(error);
                this.ticketPositionList = [];
            }).finally(() => {
                this.ticketPositionLoading = false;
            });
        },
        loadTicketPositionOptions() {
            axios.get('/zhaopinapi/recruit-position-info/find-page', {
                headers: this.authHeaders(),
                params: {
                    current: 1,
                    size: 500,
                    talentType: this.ticketPositionTalentType,
                    isDeleted: 0,
                },
            }).then((res) => {
                if (this.apiOk(res) && res.data.data && res.data.data.records) {
                    this.ticketPositionOptions = res.data.data.records.map((p) => ({
                        id: p.id,
                        label: this.formatRecruitPositionLabel(p),
                    }));
                } else {
                    this.ticketPositionOptions = [];
                }
            }).catch(() => {
                this.ticketPositionOptions = [];
            });
        },
        formatRecruitPositionLabel(p) {
            if (!p) return '';
            const t = p.talentType != null ? Number(p.talentType) : this.ticketPositionTalentType;
            if (t === 0) {
                return (p.majorCategory || '') + ' - ' + (p.majorName || '');
            }
            if (t === 1) {
                return p.undergraduateMajorName || p.majorName || '';
            }
            const wt = p.workType === 0 ? '煤矿井下一线' : (p.workType === 1 ? '化工生产一线' : '');
            return (wt ? wt + ' - ' : '') + (p.majorCategory || '');
        },
        openTicketPositionDialog(item) {
            this.loadTicketPositionOptions();
            if (item && item.id) {
                this.ticketPositionDialogTitle = '编辑岗位配置';
                this.ticketPositionForm = {
                    id: item.id,
                    recruitPositionInfoId: item.recruitPositionInfoId,
                    range: [item.openStart, item.openEnd],
                    remark: item.remark || '',
                };
            } else {
                this.ticketPositionDialogTitle = '新增岗位配置';
                this.ticketPositionForm = {
                    id: null,
                    recruitPositionInfoId: null,
                    range: [],
                    remark: '',
                };
            }
            this.ticketPositionDialogVisible = true;
        },
        saveTicketPosition() {
            const f = this.ticketPositionForm;
            if (!f.recruitPositionInfoId) {
                this.$message.warning('请选择招聘岗位');
                return;
            }
            if (!f.range || f.range.length !== 2) {
                this.$message.warning('请选择开放时间');
                return;
            }
            this.ticketPositionSaving = true;
            axios.put('/zhaopinapi/exam-ticket-print-window/save', {
                id: f.id,
                scopeType: 1,
                recruitPositionInfoId: f.recruitPositionInfoId,
                openStart: f.range[0],
                openEnd: f.range[1],
                remark: f.remark,
            }, { headers: this.authHeaders() }).then((res) => {
                if (this.apiOk(res)) {
                    this.$message.success('保存成功');
                    this.ticketPositionDialogVisible = false;
                    this.loadTicketPositionList();
                } else {
                    this.$message.warning(res.data.message || '保存失败');
                }
            }).catch(() => {
                this.$message.error('保存失败');
            }).finally(() => {
                this.ticketPositionSaving = false;
            });
        },
        deleteTicketPosition(item) {
            if (!item || !item.id) return;
            this.$confirm('确定删除该岗位的个性化开放时间配置？', '提示', {
                type: 'warning',
            }).then(() => {
                axios.delete('/zhaopinapi/exam-ticket-print-window/position/' + item.id, {
                    headers: this.authHeaders(),
                }).then((res) => {
                    if (this.apiOk(res)) {
                        this.$message.success('已删除');
                        this.loadTicketPositionList();
                    } else {
                        this.$message.warning(res.data.message || '删除失败');
                    }
                });
            }).catch(() => {});
        },
        openLogDetail(row) {
            if (!row || !row.id) {
                this.logDetail = row;
                this.logDetailVisible = true;
                return;
            }
            axios.get('/zhaopinapi/system-access-log/' + row.id, {
                headers: this.authHeaders(),
            }).then((res) => {
                if (this.apiOk(res) && res.data.data) {
                    this.logDetail = res.data.data;
                    this.logDetailVisible = true;
                } else {
                    this.$message.warning(res.data.message || '加载详情失败');
                }
            }).catch(() => {
                this.logDetail = row;
                this.logDetailVisible = true;
            });
        },
    }
}
</script>

<style scoped>
    .pageManager-m{padding: 30px 0;}
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .manager-rig{}
    .manager-rt{height: 42px; padding-bottom: 18px;}
    .manager-rtle{font-size: 24px; line-height: 40px; float: left; font-weight: bold;}
    .manager-setM{border-radius: 10px; padding: 30px; border: 1px solid #F3F4F6; background: #fff;}
    .manager-set-ocr{margin-top: 24px;}
    .manager-set-ticket{margin-top: 24px;}
    .manager-set-user{margin-top: 24px;}
    .ticket-global-block{margin-bottom: 28px; padding-bottom: 20px; border-bottom: 1px dashed #E5E7EB;}
    .ticket-block-title{font-size: 15px; font-weight: bold; margin-bottom: 12px; color: #111827;}
    .ticket-position-add{float: right;}
    .ticket-position-block{padding-top: 4px;}
    .manager-set-ocr-desc{margin: 0 0 16px; font-size: 13px; color: #6B7280; line-height: 1.6;}
    .ocr-entrance-block{margin-bottom: 24px; padding-bottom: 16px; border-bottom: 1px dashed #E5E7EB;}
    .ocr-entrance-block:last-of-type{border-bottom: none;}
    .ocr-entrance-title{font-size: 16px; font-weight: bold; margin-bottom: 12px; color: #111827;}
    .ocr-highest-block{margin-bottom: 14px; padding: 12px 16px; background: #F9FAFB; border-radius: 8px;}
    .ocr-highest-title{font-size: 13px; font-weight: 600; margin-bottom: 10px; color: #374151;}
    .ocr-segment-row{display: flex; flex-wrap: wrap; gap: 16px 32px;}
    .ocr-segment-item{display: flex; align-items: center; gap: 12px;}
    .ocr-segment-label{font-size: 13px; color: #4B5563; min-width: 100px;}
    .ocr-save-row{padding-top: 8px;}
    .manager-set-log{margin-top: 24px;}
    .manager-set-log-userid{width: 120px; float: left; margin-right: 12px;}
    .manager-set-log-url{width: 280px; float: left; margin-right: 12px;}
    .manager-set-log-success{width: 120px; float: left; margin-right: 12px;}
    .manager-set-log-page{padding: 20px 0 8px;}
    .log-url-cell{max-width: 320px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;}
    .log-detail-body p{margin: 0 0 10px; line-height: 1.6; word-break: break-all;}
    .log-detail-label{margin-top: 12px !important;}
    .log-detail-pre{
        max-height: 200px;
        overflow: auto;
        background: #f9fafb;
        padding: 12px;
        border-radius: 8px;
        font-size: 12px;
        line-height: 1.5;
        white-space: pre-wrap;
        word-break: break-all;
        margin: 0 0 16px;
    }
    .manager-setMt{font-size: 14px; font-weight: bold; line-height: 20px; padding-bottom: 12px;}
    .manager-set-entry-toolbar{padding-bottom: 16px;}
    .manager-set-entry-search{width: 220px; float: left; margin-right: 12px;}
    .manager-set-entry-type{width: 160px; float: left; margin-right: 12px;}
    .manager-set-entry-add{float: right;}
    .manager-set-entry-table{padding-bottom: 8px;}
    .manager-set-entry-empty{text-align: center; color: #99A1AF !important;}
    .entry-del-btn{color: #E7000B !important;}
    .manager-job-table{width: 100%; border-collapse: collapse; border-spacing: 0; border-radius: 10px;}
    .manager-job-table td{padding: 5px 20px; line-height: 20px !important; background: #fff; border-bottom: 1px solid #f9fafb;}
    .manager-job-table th{padding: 15px 20px; line-height: 20px; background: #f9fafb; border-bottom: 1px solid #f9fafb; text-align: left;}
    .manager-job-table tr:hover td{background: #f9fafb;}
    .clearfix:after{content: ''; display: block; clear: both;}

    .el-input__inner {
        background-color: #F7F7F7 !important; /* 使用!important确保优先级 */
    }
</style>
